import React from "react";

const InputLayout = ({ children, classes, style , onClick }) => {
  return (
    <div className={`col-sm ${classes}`} style={style}  onClick={onClick}>
      <div className="form-group">{children}</div>
    </div>
  );
};

export default InputLayout;
